var render, staticRenderFns
import script from "./CardSubtitle.vue?vue&type=script&lang=ts&"
export * from "./CardSubtitle.vue?vue&type=script&lang=ts&"
import style0 from "./CardSubtitle.vue?vue&type=style&index=0&id=9535322a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports